<template>
  <v-card
    class=" bid-history-participant-card main__light_green rounded-lg pa-8 pb-4"
    :class="{'secondary__green_chosen': opened}"
    elevation="0"
    :ripple="false"
    @click="openAll">
    <v-row
      class="pb-1"
      no-gutters>
      <v-card-title class="pa-0 h3-headline text-start participant-wrapper">
        <template v-if="participant.bidderInfo && participant.bidderInfo.verificationStatus == 'VERIFIED'">
          <TooltipedBtn
            v-if="participant.bidderInfo.verificationDecision == 'RECOMENDED'"
            color="var(--v-green_chosen-base)"
            icon="accept"
            :text="$t('Suppliers.RecommendedForCoperation')"/>
          <TooltipedBtn
            v-else
            color="var(--v-secondary__red-base)"
            icon="info"
            :text="$t('Suppliers.NotRecommendedForCoperation')"/>
        </template>
        <router-link
          :to=" {name: 'bidsHistoryByParticipants',
                 params: { tenderId: tender.tenderId, org: $route.params.org, participantId: participant.bidderId}} ">
          <span
            class="participant-name">{{ participant.bidderTitle }}</span>
          <ExternalParticipantChip
            v-if="participant.foreignBidderBid"
            class="mt-2"/>
        </router-link>
      </v-card-title>
      <v-card-subtitle class="ma-0 ml-auto pa-0 h7-text d-flex ">
        {{ $t('Tenders.Rating') }}: {{ participant.bidderRating }}
      </v-card-subtitle>
    </v-row>

    <v-card-text class=" px-0 pt-5 pb-4 flex-row d-flex ">
      <v-row no-gutters>
        <v-col
          class="mr-3"
          cols="2">
          <div class="h9-label px-0 pb-1">
            {{ $t('Tenders.ParticipationInLots') }}
          </div>
          <div class="text-left h7-text black--text">
            {{ participant.participationsNumber }}
            {{ $t('Catalog.of') }}
            {{ all_lots }}
          </div>
        </v-col>
        <v-col
          v-if="!($can('hide', 'PricesOnPrequalification') && tender.tenderStatus.id == 5)"
          class="mr-3"
          cols="3">
          <div class="h9-label px-0 pb-1">
            {{ $t('Tenders.FinalProposalSumm') }}
          </div>
          <div class="text-left h7-text black--text">
            {{ $n(participant.finalOfferSumCurrency, 'decimal') }} {{ currency }}
            <CurrencyConversionTooltip
              v-if="currencyCode !== 980"
              :currency="currency"
              :current-id="currencyCode"
              :price="participant.finalOfferSumCurrency"/>
          </div>
        </v-col>
        <v-col
          class="mr-3"
          cols="3">
          <div class="h9-label px-0 pb-1">
            {{ $t('Tenders.FinalProposalDate') }}
          </div>
          <div class="text-left h7-text black--text">
            {{ participant.finalOfferDateTime | formatDate }}
          </div>
        </v-col>
        <div class="spacer"/>
        <v-col
          align-self="end"
          class="d-flex align-end h7-text black--text justify-end"
          cols="1">
          <CancelledBidInfo :cancelled="cancelled"/>
        </v-col>
      </v-row>
    </v-card-text>
    <v-expand-transition>
      <div
        v-if="participant.bidderInfo"
        v-show="opened">
        <sDivider/>
        <v-row
          class="pt-5"
          no-gutters>
          <v-col
            class="mr-3 "
            cols="2">
            <div class="h9-label px-0 ">
              {{ $t('Tenders.EDRPOU') }}
            </div>
            <div class="text-left px-0 h7-text py-1 black--text text-decoration-underline">
              {{ participant.bidderInfo.usreou || '–' }}
              <sButton
                v-if="participant.bidderInfo.usreou"
                icon="draft"
                small
                type="text"
                @click="copy(participant.bidderInfo.usreou)"/>
            </div>
          </v-col>
          <v-col
            class="mr-3 "
            cols="3">
            <div class="h9-label px-0 pb-1">
              {{ $t('Tenders.ContactPerson') }}
            </div>
            <div class="text-left h7-text">
              {{ participant.bidderInfo.fullName || '–' }}
            </div>
          </v-col>
          <v-col
            class="mr-3  pt-4 h8-text grey--text "
            cols="3">
            <div class="text-left">
              {{ participant.bidderInfo.email || '–' }}
            </div>
            <div class="text-left">
              {{ participant.bidderInfo.phoneNumber || '–' }}
            </div>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import CancelledBidInfo from 'components/tenders/CancelledBidInfo.vue'
import ExternalParticipantChip from 'components/tenders/tender page/ExternalParticipantChip.vue'
import CurrencyConversionTooltip from 'components/common/elements/CurrencyConversionTooltip.vue'

import moment from 'moment'
import { modalMixin, tenderMixin } from 'mixins'

export default {
  name: 'bidHistoryParticipantCard',
  mixins: [tenderMixin, modalMixin],
  data() {
    return {
      opened: false
    }
  },
  props: {
    tender: Object,
    participant: Object
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('DD MMMM, HH:mm')
      }
    },
  },
  computed: {
    currencyCode() {
      return this.participant?.currency?.code || null
    },
    all_lots() {
      return this.tender.lots.length
    },
    currency() {
      return this.participant.currency?.title ||  '–'
    },
    now() {
      return moment().format()
    },
    cancelled() {
      return this.participant.cancelledBidsCount
    }
  },
  methods: {
    openAll() {
      this.opened = !this.opened
    },
  },
  components: {
    TooltipedBtn,
    CancelledBidInfo,
    ExternalParticipantChip,
    CurrencyConversionTooltip
  }
}
</script>
<style lang="scss" scoped>
.h9-label {
  width: max-content;
}

.bid-history-participant-card {
  &::before {
    opacity: 0 !important;
  }
}
</style>
